export const ACTION_SHOW_DIALOG = 'action_show_dialog';
export const ACTION_HIDE_DIALOG = 'action_hide_dialog';